const styles = {
  container: {
    width: 'fit-content',
    visibility: 'visible'
  },
  hidden: {
    visibility: 'hidden',
  }
}

export default styles;